import { defineMessages } from 'react-intl';

export default defineMessages({
  assets: `Assets`,
  marketSize: `Market size`,
  totalBorrowed: `Total borrowed`,
  depositAPY: `Deposit APY`,
  borrowAPY: `Borrow APY`,
  stable: 'Stable',
  variable: 'Variable',
});
